var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0378C0 5.14673 4.77563 0.371094 10.6667 0.371094H85.3333C91.2244 0.371094 96 5.14672 96 11.0378V85.7044C96 91.5955 91.2244 96.3711 85.3333 96.3711H10.6667C4.77563 96.3711 0 91.5955 0 85.7044V11.0378Z",
    fill: "url(#paint0_linear_1972_80269)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_80269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 65,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9999,
    y: 16.3594,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_80269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7708 69.0573C49.9957 69.0573 45.1041 67.0533 41.096 63.0452C37.0879 59.0371 35.0839 54.1455 35.0839 48.3705C35.0839 42.6385 37.0879 37.7577 41.096 33.728C45.1041 29.6984 49.9957 27.6836 55.7708 27.6836C61.5027 27.6836 66.3835 29.6984 70.4132 33.728C74.4428 37.7577 76.4576 42.6385 76.4576 48.3705C76.4576 54.1455 74.4428 59.0371 70.4132 63.0452C66.3835 67.0533 61.5027 69.0573 55.7708 69.0573ZM55.7708 63.8856C60.0805 63.8856 63.7438 62.3772 66.7607 59.3604C69.7775 56.3435 71.2859 52.6802 71.2859 48.3705C71.2859 44.0607 69.7775 40.3974 66.7607 37.3806C63.7438 34.3637 60.0805 32.8553 55.7708 32.8553C51.461 32.8553 47.7977 34.3637 44.7809 37.3806C41.764 40.3974 40.2556 44.0607 40.2556 48.3705C40.2556 52.6802 41.764 56.3435 44.7809 59.3604C47.7977 62.3772 51.461 63.8856 55.7708 63.8856ZM58.3566 47.3361V40.6129C58.3566 39.8802 58.1088 39.2661 57.6132 38.7705C57.1176 38.2748 56.5034 38.027 55.7708 38.027C55.0381 38.027 54.424 38.2748 53.9283 38.7705C53.4327 39.2661 53.1849 39.8802 53.1849 40.6129V48.4351C53.1849 48.7799 53.2603 49.1139 53.4112 49.4371C53.562 49.7604 53.7452 50.0297 53.9607 50.2452L59.8435 56.128C60.3607 56.6452 60.9748 56.9038 61.6859 56.9038C62.397 56.9038 63.0112 56.6452 63.5283 56.128C64.0455 55.6109 64.3041 54.9967 64.3041 54.2856C64.3041 53.5745 64.0455 52.9604 63.5283 52.4432L58.3566 47.3361ZM24.7404 40.6129C24.0078 40.6129 23.3936 40.3651 22.898 39.8695C22.4024 39.3738 22.1546 38.7597 22.1546 38.027C22.1546 37.2944 22.4024 36.6802 22.898 36.1846C23.3936 35.689 24.0078 35.4412 24.7404 35.4412H29.9122C30.6448 35.4412 31.259 35.689 31.7546 36.1846C32.2502 36.6802 32.498 37.2944 32.498 38.027C32.498 38.7597 32.2502 39.3738 31.7546 39.8695C31.259 40.3651 30.6448 40.6129 29.9122 40.6129H24.7404ZM22.1546 50.9563C21.4219 50.9563 20.8078 50.7085 20.3122 50.2129C19.8165 49.7173 19.5687 49.1031 19.5687 48.3705C19.5687 47.6378 19.8165 47.0237 20.3122 46.528C20.8078 46.0324 21.4219 45.7846 22.1546 45.7846H29.9122C30.6448 45.7846 31.259 46.0324 31.7546 46.528C32.2502 47.0237 32.498 47.6378 32.498 48.3705C32.498 49.1031 32.2502 49.7173 31.7546 50.2129C31.259 50.7085 30.6448 50.9563 29.9122 50.9563H22.1546ZM24.7404 61.2998C24.0078 61.2998 23.3936 61.0519 22.898 60.5563C22.4024 60.0607 22.1546 59.4466 22.1546 58.7139C22.1546 57.9812 22.4024 57.3671 22.898 56.8715C23.3936 56.3759 24.0078 56.128 24.7404 56.128H29.9122C30.6448 56.128 31.259 56.3759 31.7546 56.8715C32.2502 57.3671 32.498 57.9812 32.498 58.7139C32.498 59.4466 32.2502 60.0607 31.7546 60.5563C31.259 61.0519 30.6448 61.2998 29.9122 61.2998H24.7404Z",
    fill: "url(#paint1_linear_1972_80269)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_80269",
    x1: 0,
    y1: 96.3711,
    x2: 113.373,
    y2: 66.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1972_80269",
    x1: 19.5687,
    y1: 69.0573,
    x2: 83.1149,
    y2: 46.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.fe3b9b338a8e40fb9c8f882c0d9923a1.svg";
export { ForwardRef as ReactComponent };